import * as React from 'react'

export function useMediaQuery(query: string, defaultValue = true) {
  const [isMatching, setIsMatching] = React.useState(defaultValue)

  React.useEffect(() => {
    const result = matchMedia(query)
    setIsMatching(result.matches)

    function onChange(event: MediaQueryListEvent) {
      setIsMatching(event.matches)
    }

    result.addEventListener('change', onChange)
    return () => result.removeEventListener('change', onChange)
  }, [query])

  return isMatching
}
